import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { fg } from '@atlaskit/platform-feature-flags';
import { Pressable, xcss } from '@atlaskit/primitives';
import { HoverCard } from '@atlaskit/smart-card/hover-card';
import { useAIEventsInstrumentation } from '@atlassian/ai-analytics';
import { SainAction, useSAINUsageCriteriaMet } from '../../../../common/controller/analytics';
import { extractUrlHostname } from '../../../../utils';
import { useAIAnswerContext } from '../../../ai-answer-context';
import { onAIAnswerSourceClick } from '../../../analytics';
var convertColorAppearance = function convertColorAppearance(color) {
  switch (color) {
    case 'blue':
      return 'inprogress';
    case 'green':
      return 'success';
    case 'red':
      return 'removed';
    case 'yellow':
      return 'moved';
    case 'purple':
      return 'new';
    default:
      return 'default';
  }
};
var citationStyles = xcss({
  border: 'none',
  background: 'none',
  padding: 'space.0',
  ':hover': {
    cursor: 'pointer'
  }
});
export var StatusCitation = function StatusCitation(_ref) {
  var localId = _ref.localId,
    text = _ref.text,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color;
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent;
  var sources = commonAttributes.sources;
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useAIEventsInstrumen = useAIEventsInstrumentation(),
    trackAIResultAction = _useAIEventsInstrumen.trackAIResultAction;
  var _useMemo = useMemo(function () {
      var _localId$split;
      if (!localId.includes('citation')) {
        return {};
      }
      var idx = parseInt((_localId$split = localId.split('-')) === null || _localId$split === void 0 ? void 0 : _localId$split[1]);
      return {
        source: sources[idx - 1],
        idx: idx
      };
    }, [localId, sources]),
    source = _useMemo.source,
    idx = _useMemo.idx;
  var handleClick = useCallback(function (source, idx) {
    fireAnalyticsEvent(onAIAnswerSourceClick(_objectSpread({
      sourceIndex: idx,
      isCitation: true,
      hostname: extractUrlHostname(source.url)
    }, commonAttributes)));
    fg('kd_enable_new_usage_tracking') ? fireSAINUsageEvent({
      metCriteria: SainAction.SOURCE_CLICKED,
      commonAttributes: commonAttributes
    }) : trackAIResultAction(SainAction.SOURCE_CLICKED);
    window.open(source.url, '_blank', 'noopener, noreferrer');
  }, [commonAttributes, fireAnalyticsEvent, fireSAINUsageEvent, trackAIResultAction]);
  if (!!source) {
    return /*#__PURE__*/React.createElement(HoverCard, {
      url: source.url
    }, /*#__PURE__*/React.createElement(Pressable, {
      xcss: citationStyles,
      onClick: function onClick() {
        handleClick(source, idx);
      }
    }, /*#__PURE__*/React.createElement(Lozenge, {
      appearance: "inprogress"
    }, idx)));
  }

  // Standard lozenge for status nodes
  return /*#__PURE__*/React.createElement(Lozenge, {
    appearance: convertColorAppearance(color)
  }, text);
};